// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"25cfdf81","171":"d08ea637","374":"307ddaa0","447":"a749c287","453":"51b8978f","507":"b9ca1af3","526":"ad8b7890","768":"e8ecc0a1","801":"c389b304","845":"736546ca","858":"4c22f16e","870":"0996872d","895":"8743ff3b"}[chunkId] + ".chunk.js";
};